module.exports = {
    API_URL: 'https://api-demo.lancastersweep.com',
    // API_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000',
    APP_VERSION: process.env.APP_VERSION || 'v1.0.0',
    APP_ENVIRONMENT: 'SANDBOX',
}
